var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M25.514 1.707C24.582.641 23.312.044 21.988.047c-1.33 0-2.582.592-3.523 1.659L12.27 8.739l.004.005-6.887 7.82c-.552.622-.862 1.468-.86 2.35 0 .887.304 1.724.86 2.354.553.628 1.288.974 2.071.974.782 0 1.519-.346 2.07-.974l11.68-13.256-1.237-1.407L8.293 19.86h-.001a1.11 1.11 0 0 1-1.666.002 1.434 1.434 0 0 1-.348-.947c0-.355.125-.696.348-.947L19.788 3.028l-.005-.006c.602-.634 1.378-.985 2.205-.985.86-.003 1.683.382 2.29 1.07.606.69.946 1.626.943 2.6 0 .98-.336 1.904-.945 2.595l-5.958 6.764-.103.119-7.438 8.441h-.001c-.989 1.128-2.334 1.76-3.736 1.756-1.403.005-2.75-.628-3.74-1.756-.994-1.123-1.553-2.651-1.548-4.244 0-1.606.549-3.113 1.547-4.246l12.095-13.73L14.154 0 2.063 13.731C.738 15.227-.005 17.261 0 19.381c0 2.134.732 4.141 2.062 5.648 1.33 1.51 3.096 2.341 4.976 2.341h.002c1.879 0 3.646-.83 4.975-2.34L22.533 13.09l.11-.126 2.872-3.26v.002c.936-1.06 1.461-2.5 1.457-4.002 0-1.512-.518-2.93-1.459-4l.001.002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon_attachment.a3450a8d29024c0109781a5dafeeea8e.svg";
export { ForwardRef as ReactComponent };